<template>
  <div class="main-wrap">
    <div class="header">
      <div class="title">
        <span class="title-text">
          <img v-if="scoolLogo" style="height: 60px; width: 60px; margin-bottom: -12px; margin-right: -20px; " :src="scoolLogo" />
          {{scoolName}}
        </span>
        <span class="time">{{dateTimeObj.currentTime}}</span>
      </div>
      <div class="status-text">{{noticeText}}</div>
      <div class="date">{{dateTimeObj.currentDate}}</div>
    </div>
    <div class="body">
      <div class="title">
        <span class="wfx">未放学</span>
        <span class="fxz">放学中</span>
        <span class="yfx">已放学</span>
      </div>
      <div class="content">
        <vueSeamlessScroll :data="weifxArr" :class-option="defaultOption" class="wfx-box">
          <div class="content-flex">
            <span class="item" :style="{width: item.classType===1 ? '100%' : '50%' }" v-for="item of weifxArr" :key="item.id">{{item.className}}</span>
          </div>
        </vueSeamlessScroll>
        <vueSeamlessScroll :data="fxzhongArr" :class-option="defaultOption2" class="fxz-box">
          <div class="content-flex">
            <span
              class="item"
              style="width:100%"
              v-for="item of fxzhongArr"
              :key="item.id"
            >{{item.className}}</span>
          </div>
        </vueSeamlessScroll>
        <vueSeamlessScroll :data="yifxArr" :class-option="defaultOption" class="yfx-box">
          <div class="content-flex">
            <span class="item" :style="{width: item.classType===1 ? '100%' : '50%' }" v-for="item of yifxArr" :key="item.id">{{item.className}}</span>
          </div>
        </vueSeamlessScroll>
      </div>
    </div>
    <div class="footer">
      <span>未放学</span>
      <span>放学中</span>
      <span>已放学</span>
    </div>
  </div>
</template>

<script>
import myMixin from "./mixin/index.js";

export default {
  mixins: [myMixin],
};
</script>

<style lang='scss' scoped>
.main-wrap {
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/images/第一版背景.png") no-repeat center;
  background-size: 100% 100%;

  .header {
    height: 20%;
    // border: greenyellow 1px solid;
    .title {
      height: 40%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: white;
      .title-text {
        width: 80%;
        font-size: 6rem;
        padding-left: 5%;
        letter-spacing: 10px;
        text-shadow: 0 0 20px #fff;
      }
      .time {
        width: 20%;
        font-size: 5rem;
        margin-top: 5%;
        text-align: right;
        padding-right: 5vw;
      }
    }
    .status-text {
      height: 30%;
      color: #fffc00;
      font-size: 4rem;
      text-align: center;
    }
    .date {
      height: 30%;
      color: white;
      font-size: 3.5rem;
      text-align: right;
      padding-right: 5vw;
    }
  }
  .body {
    height: 70%;
    // border: hotpink 1px solid;
    .title {
      height: 11%;
      font-size: 4rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .wfx {
        color: #ff0000;
        width: 30%;
        padding-left: 4%;
      }
      .fxz {
        color: #fa7ced;
        width: 30%;
        padding-left: 2%;
      }
      .yfx {
        color: #00ff5a;
        width: 35%;
      }
    }

    .content {
      margin-top: 1.5%;
      height: 80%;
      font-size: 4.2rem;
      display: flex;

      .wfx-box {
        color: #ff0000;
        // border: 1px solid white;
        width: 30%;
        margin-left: 2%;
        overflow: hidden;
      }
      .fxz-box {
        color: #fa7ced;
        // border: 1px solid rgb(245, 9, 60);
        width: 25.5%;
        margin-left: 3.5%;
        overflow: hidden;
      }
      .yfx-box {
        color: #00ff5a;
        // border: 1px solid white;
        width: 34%;
        margin-left: 3%;
        overflow: hidden;
      }

      .content-flex {
        display: flex;
        justify-content: flex-start;
        flex-flow: row wrap;
        align-content: flex-start;

        .item {
          width: 50%;
          height: 7vh;
          line-height: 7vh;
          text-align: center;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
        }
      }
    }
  }
  .footer {
    margin-top: 3vh;
    font-size: 4rem;
    display: flex;
    justify-content: space-around;

    span:nth-of-type(1) {
      color: #ff0000;
      width: 33%;
      text-align: right;
      padding-right: 5%;
    }
    span:nth-of-type(2) {
      color: #fa7ced;
      width: 33%;
      position: relative;
      bottom: 5px;
      text-align: center;
      padding-right: 3%;
    }
    span:nth-of-type(3) {
      color: #00ff5a;
      width: 33%;
      padding-left: 2%;
    }
  }
}
</style>
